import { useQuery } from 'react-query';
import { useAppSelector } from 'store';
import { DjangoListResponse, SearchEntity } from 'v2/models';
import restFactory from 'v2/utils/restFactory';
import { hasRequestsPermission } from 'v2/utils/user';

export interface ISearchKeyProps {
  depth?: 'individual';
  review_status?: 'under_review';
  active: boolean;
}

export function getKey(params: ISearchKeyProps) {
  return ['Searches', params];
}

export function useSearches(props: ISearchKeyProps) {
  const permissions = useAppSelector((store) => store.permissions.permissions);
  const enabled = hasRequestsPermission(permissions);
  return useQuery(
    getKey(props),
    () =>
      restFactory.get<DjangoListResponse<SearchEntity>>(
        `/dj/api/v1/search/`,
        props
      ),
    { enabled }
  );
}
